import { http } from '@/utils'
// 人员信息详情
export const personnelDetails = (id?: any): any =>
  http.get(`/hrm/employee/${id}`, { params: { id } })
// 调整记录 添加/编辑
export const saveSocialSecurityAdjust = (data: any): any =>
  http.post('/social_security/profile/adjust', data)
// 调整记录 批量删除
export const deleteSocialSecurityAdjust = (data: any): any =>
  http.delete('/social_security/profile/adjust', { data })
